export const getComponentsFromPrismic = prismicData => prismicData.edges[0].node.data.body[0].items;
